<template>
  <div class="container-fluid">
    <div class="row">
      <div class="stock-search-bar">
        <button class="barcode-scanner text-white" @click="openTables">
          <font-awesome-icon icon="fa-solid fa-table"/>
        </button>

        <input v-model="input"  @keyup.enter="onBarcodeScanned(input)"
               class="ml-2 stock-search-field form-control"
               placeholder="PLU, Barcode,Description" type="text">


        <button @click="onBarcodeScanned(input)" type="button" class="barcode-scanner mx2 text-white">
          <font-awesome-icon icon="fa-solid fa-magnifying-glass"/>
        </button>

        <button @click="open" class="barcode-scanner viewOrder text-white">
          <span class="badge" v-if="saleUnits>0">{{ saleUnits }}</span>
          <font-awesome-icon icon="fa-solid fa-cart-shopping"/>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StockSearchBar",
  components: {},
  computed: {
    saleUnits() {
      return this.$store.getters.getSaleUnits
    },
    category() {
      return this.$store.getters.getCurrentCategory
    },
    subCategory() {
      return this.$store.getters.getSubCategory
    },
    sub2Category() {
      return this.$store.getters.getSubCategory2
    },
    isTabOpen() {
      return this.$store.getters.getIsTabOpen
    },
    customerDetails() {
      return this.$store.getters.getCustomer;
    }
  },
  data() {
    return {
      input: '',

    }
  },
  methods: {
    open() {
      this.$router.push({name: 'viewSale'})
    },
    search(e) {
      this.getStock()
    },
    openTables() {
      return this.$router.push({name: 'tables'})
    },
    addScaleItem(itemObj) {
      this.$store.dispatch('getStockSetting', itemObj.PLU).then((set) => {
        if (!set) {
          set = { cookingLink: false, askForPrice: false, askForDescription: false, askForBoth: false };
        }
        if (set.cookingLink) {
          this.$router.push({name: 'instruction', params: {plu: itemObj.PLU}})
          return;
        }
        let price = itemObj.SellingIncl;
        let specialPrice = this.$store.getters.getItemSpecialPrice(itemObj.PLU)
        if (specialPrice){
          responses.showSuccess(`Special Detected`)
          price = specialPrice;
        }
        let obj = {
          Plu: itemObj.PLU,
          Description: itemObj.Description,
          Qty: itemObj.Qty,
          // Preserve the server-supplied unit price precision (e.g. 0.234
          // is sent by the API as 3 dp; truncating to 2 dp here was
          // making the cart and the invoice payload show 0.23 instead).
          Unit: price,
          // Line is a money total — keep at 2 dp.
          Line: Number((price * itemObj.Qty).toFixed(2)),
          Discount: 0,
          vat: 0,
          instructions: []
        }
        this.$store.commit('addToCurrentSaleLines', obj)
      });
    },
    addToSale(item) {
      return this.$store.dispatch('getStockSetting', item.PLU)
          .then(async (set) => {
            if (!set) {
              set = { cookingLink: false, askForPrice: false, askForDescription: false, askForBoth: false };
            }
            // Preserve the server-supplied unit price precision. The
            // previous Number(item.SellingIncl.toFixed(2)) was truncating
            // 3-dp prices like 0.234 down to 0.23, which then propagated
            // into the cart display and the invoice payload.
            let price = item.SellingIncl;
            let description = item.Description;

            if (set.askForDescription || set.askForBoth) {
              description = (await this.askForDescription(item));
            }

            if (set.askForPrice || set.askForBoth) {
              price = (await this.askForPrice(item));
            } else if (this.customerDetails) {
              price = this.$store.getters.getDebtorPrice({
                id : this.customerDetails,
                item : item
              });
            }



            if (set.cookingLink) {
              return this.$router.push({name: 'instruction', params: {plu: item.PLU}})
            }
            let obj = {
              Plu: item.PLU,
              Description: description,
              Qty: 1,
              Unit: price,
              // Line is a money total — round to 2 dp.
              Line: Number((price * 1).toFixed(2)),
              Discount: 0,
              vat: 0,
              priceType : this.$store.getters.getCurrentDebtorPriceType.DiscountType,
              instructions: []
            }
            this.$store.commit('addToCurrentSaleLines', obj)
          })
    },
    askForPrice(item) {
      this.$store.commit('setIsTabOpen', true)
      return Swal.fire({
        allowOutsideClick: false,
        showCancelButton: true,
        showLoaderOnConfirm: true,
        title: `Set Selling Price`,
        html: `<h6 >Description : ${item.Description}</h6>
               <h6 >Current Price : ${item.SellingIncl}</h6>
               <input type="number" step="0.001" id="selling-prc" class="swal2-input" placeholder="Selling Price" style="max-width: 70%">`,
        confirmButtonText: 'Set Price',
        focusConfirm: false,
        preConfirm: async () => {
          let value = Swal.getPopup().querySelector('#selling-prc').value;
          if (!value) {
            Swal.showValidationMessage(`Please enter a valid Selling Price`)
          }
          return parseFloat(value);
        }
      }).then(result => {
        this.$store.commit('setIsTabOpen', false)
        if (result.isConfirmed) {
          return result.value;
        }
        // Preserve the server-supplied price precision (e.g. 0.234)
        // instead of truncating to 2 dp.
        return item.SellingIncl;
      })
    },
    askForDescription(item) {
      this.$store.commit('setIsTabOpen', true)
      return Swal.fire({
        allowOutsideClick: false,
        showCancelButton: true,
        showLoaderOnConfirm: true,
        title: `Set Description`,
        html: `<h6 >Description : ${item.Description}</h6>
               <textarea id="desc-ask" class="swal2-input" placeholder="Description" style="max-width: 70%">`,
        confirmButtonText: 'Set Description',
        focusConfirm: false,
        preConfirm: async () => {
          let value = Swal.getPopup().querySelector('#desc-ask').value
          if (!value || value.toString().trim() === "") {
            Swal.showValidationMessage(`Please enter a valid Description`)
          }
          return value;
        }
      }).then(result => {
        this.$store.commit('setIsTabOpen', false)
        if (result.isConfirmed) {
          return result.value;
        }
        return item.Description
      })
    },
    getStock() {
      this.$utils.showLoading()
      const query = {
        description: this.input,
        category: '',
        subCategory: '',
        sub2Category: ''
      }
      return this.$store.dispatch('searchDescription', query)
          .finally(() => this.$utils.hideLoading())
    },
    hasLetters(inputString) {
      return /[a-zA-Z]/.test(inputString);
    },
    async onBarcodeScanned(barcode) {
      if (barcode.slice(-5) === `Enter`) {
        barcode = barcode.slice(0, -5);
      }
      if (!this.isTabOpen) {
        try {
          this.$store.commit(`setIsTabOpen`,true)
          let item;
          item = this.$store.getters.getByPlu(barcode)
          if (!item) {
            item = this.$store.getters.getByPlu(barcode.slice(1))
          }

          if (!item) {
            let itemBarcode = barcode.slice(0, -1);
            item = this.$store.getters.getByPlu(itemBarcode)
          }

          let settings = this.$store.getters.getDeviceSettings;
          let flag = barcode.substring(0, 2);
          if (!item && barcode.length === 13 && settings && settings.Flag.toString() === flag) {
            let scaleItemPLU = barcode.toString().substring(2, 6);
            item = this.$store.getters.getByPlu(scaleItemPLU)
            if (item) {
              let barcodePrice = barcode.toString().substring(6, 12);
              barcodePrice = barcodePrice.substring(0, 4) + '.' + barcodePrice.substring(4, 6);
              barcodePrice = Number(barcodePrice);
              let qty = barcodePrice / item.SellingIncl;
              // Round to 4 dp (canonical sale-line qty precision) so the
              // value going into state, the cart subtotal, and the invoice
              // payload is already clean. parseFloat(qty.toFixed(3)) was
              // truncating and capping at 3 dp.
              item.Qty = this.$utils.roundTo(qty, 4);
              return this.addScaleItem(item);
            }
          }

          if (item) {
            this.addToSale(item)
            this.input = ''
          } else {
            return this.getStock();
          }
        } finally {
          this.$store.commit(`setIsTabOpen`,false)
        }
      }else {
        this.getStock()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.row {
  background: #9ccc65;
  padding: 0 10px;
}

button {
  background: #9ccc65;
}

.stock-search-bar {
  background: #92A7BA;
  padding: 5px 10px;
  display: flex;
  align-items: center;
  border-radius: 10px 10px 0 0;
  justify-content: flex-start;
  position: relative;

  .barcode-scanner {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    font-size: 24px;
  }

  .viewOrder {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;

    .badge {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: -10px;
      right: -10px;
      font-size: 8px;
      width: 24px;
      height: 24px;
      background: #9ccc65;
      border-radius: 50%;
    }
  }

  .search-icon {
    left: 67px;
    font-size: 18px;
    color: #40434A;
  }

  .stock-search-field {
    margin-left: 10px;
    height: 40px;
    width: 100%;
    border-radius: 10px;
    padding-left: 30px;
    outline: transparent;
  }
}
</style>
